import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {
  FaqContainer,
  FaqContent,
  StyledItem,
  StyledLink,
  StyledList
} from './styled';
import FAQLinks, { FAQHeading, FAQSubHeading } from './FAQData';

function FAQ(): JSX.Element {
  const renderFAQLinks = (linkURL, linkText) => (
    <StyledItem key={linkText}>
      <StyledLink data-testid="faq-link" href={linkURL}>
        {linkText}
      </StyledLink>
    </StyledItem>
  );

  const renderFAQLinksGrids = () =>
    FAQLinks.map((gridItems: FAQLink[], index: number) => (
      <Grid key={index} item xs={12} sm={6}>
        <StyledList>
          {gridItems.map((linkItem: FAQLink) =>
            renderFAQLinks(linkItem.linkURL, linkItem.linkText)
          )}
        </StyledList>
      </Grid>
    ));

  return (
    <FaqContainer>
      <Typography marginBottom="30px" variant="h2" component="div">
        {FAQHeading}
      </Typography>
      <Typography data-testid="sub-heading" variant="body2">
        {FAQSubHeading}
      </Typography>
      <FaqContent>
        <Grid container>{renderFAQLinksGrids()}</Grid>
      </FaqContent>
      <Box my={5} textAlign="center">
        <Button
          className="readings101-btn"
          variant="outlined"
          size="comfy"
          href="/psychic-advice">
          Readings 101
        </Button>
      </Box>
    </FaqContainer>
  );
}

export default FAQ;
